import axios from 'axios'

let getUrl = '/api';
const isDebugMode = false;
if (isDebugMode) {
  getUrl = 'http://localhost:8080/';
}
const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '' : getUrl,
  timeout: 10000
});

// Request interceptor
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Response interceptor
instance.interceptors.response.use(
  response => response.data,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      if (window.location.pathname !== '/lxjsadmin/login') {
        window.location.href = '/lxjsadmin/login'
      }
    }
    return Promise.reject(error)
  }
)

export default instance
